<template>
  <g>
    <g clip-path="url(#clip0_15_95)">
      <path
        d="M21.5 4.00018C20.67 4.00018 20 4.67018 20 5.50018V10.5002C20 10.7802 19.78 11.0002 19.5 11.0002C19.22 11.0002 19 10.7802 19 10.5002V2.50018C19 1.67018 18.33 1.00018 17.5 1.00018C16.67 1.00018 16 1.67018 16 2.50018V10.5002C16 10.7802 15.78 11.0002 15.5 11.0002C15.22 11.0002 15 10.7802 15 10.5002V1.50018C15 0.670183 14.33 0.000183105 13.5 0.000183105C12.67 0.000183105 12 0.670183 12 1.50018V10.4902C12 10.7702 11.78 10.9902 11.5 10.9902C11.22 10.9902 11 10.7702 11 10.4902V4.50018C11 3.67018 10.33 3.00018 9.5 3.00018C8.67 3.00018 8 3.67018 8 4.50018V15.9102L3.88 13.5602C3.3 13.2302 2.58 13.3202 2.1 13.7802C1.5 14.3602 1.48 15.3202 2.07 15.9102L8.85 22.8002C9.6 23.5702 10.62 24.0002 11.7 24.0002H19C21.21 24.0002 23 22.2102 23 20.0002V5.50018C23 4.67018 22.33 4.00018 21.5 4.00018Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_95">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
